export default function importAllImg(r: any) {
   const images: any = {}
   r.keys().map((item: any) => {
      if (item[0] !== '.') images[item.replace('./', '')] = r(item)
   })
   return images
}
